import styled, { css } from 'styled-components';
import { Spacer as ConstellationSpacer, mediaMixin } from '@zillow/constellation';

export const Content = styled.div<{ isLoading: boolean }>`
  width: 100%;
  max-width: 1220px;
  padding-top: 24px;
  ${mediaMixin(
    'lg',
    css`
      padding: 24px 24px 40px 24px;
    `,
  )};
  ${({ isLoading }) => (isLoading ? 'opacity: 50%;' : '')}
`;

interface IgnorePadding {
  ignorePadding: boolean;
}

export const Spacer = styled(ConstellationSpacer)<IgnorePadding>`
  ${({ ignorePadding }) =>
    ignorePadding
      ? `
      // override padding of parent so element reaches edge of screen
      margin-left: -24px;
      margin-right: -24px;
  `
      : ''}
`;

export const MapContainer = styled.div`
  position: relative;
  height: 320px;
  width: auto;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 60px; // necessary until we figure out where to place the "My home" buttons

  ${mediaMixin(
    'lg',
    css`
      justify-content: flex-start;
      margin-bottom: 0;
    `,
  )};
`;

export const LoadingDiv = styled.div`
  height: 100px;
  width: 100px;
`;

export const Flex = styled(ConstellationSpacer)`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;
